module.exports = __webpack_public_path__ + "img/fs_12.41464063.jpg";